<template>
    <v-container>
        <v-row text-center wrap>
            <v-col xs="12">
                <v-card>
                    <v-toolbar flat class="grey lighten-4">
                        <v-toolbar-title>Компании</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                            @click="createCompanyPopup"
                            color="success"
                        >
                            Добавить
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <v-form
                            @submit.prevent="search.filter.page = 1; searchCompanies()"
                            autocomplete="off"
                            class="col-md-8 pa-0"
                        >
                            <v-text-field
                                v-model="search.filter.term"
                                :error-messages="search.errors.term"
                                name="term"
                                label="Поиск"
                                type="text"
                                class="pa-0"
                                dense
                            ></v-text-field>
                            <v-text-field
                                v-model="search.filter.term_id"
                                :error-messages="search.errors.term_id"
                                name="term_id"
                                label="Поиск по ID"
                                type="text"
                                class="pa-0"
                                dense
                            ></v-text-field>
                            <v-text-field
                                v-model="search.filter.term_email"
                                :error-messages="search.errors.term_email"
                                name="term_phone"
                                label="Поиск по почте"
                                type="text"
                                class="pa-0"
                                dense
                            ></v-text-field>
                            <v-text-field
                                v-model="search.filter.term_phone"
                                :error-messages="search.errors.term_phone"
                                name="term_phone"
                                label="Поиск по телефону"
                                type="text"
                                class="pa-0"
                                dense
                            ></v-text-field>
                            <v-select
                                v-model="search.filter.manager_id"
                                :error-messages="search.errors.manager_id"
                                :items="manager.search.data"
                                :cache-items="true"
                                item-text="name"
                                item-value="id"
                                label="Администратор"
                                clearable
                                class="pa-0"
                                dense
                            ></v-select>
                            <v-select
                                v-model="search.filter.source_id"
                                :error-messages="search.errors.source_id"
                                :items="source.search.data"
                                :cache-items="true"
                                item-text="name"
                                item-value="id"
                                label="Источник"
                                clearable
                                class="pa-0"
                                dense
                            ></v-select>
                            <v-select
                                v-model="search.filter.status_id"
                                :error-messages="search.errors.status_id"
                                :items="status.search.data"
                                :cache-items="true"
                                item-text="name"
                                item-value="id"
                                label="Статус"
                                clearable
                                class="pa-0"
                                dense
                            ></v-select>
                            <v-row class="ma-0 pa-0">
                                <v-col md="6" class="ma-0 pa-0">
                                    <v-menu
                                        v-model="search.menu.created_from_date"
                                        ref="menuCreatedFromDate"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                        max-width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                @click:clear="search.filter.created_from_date = null"
                                                :value="createdFromDate"
                                                label="Дата добавления, от"
                                                prepend-icon="mdi-calendar"
                                                readonly
                                                clearable
                                                v-on="on"
                                                class="my-0 ml-0 pl-0 py-0"
                                                dense
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            v-model="search.filter.created_from_date"
                                            @change="search.menu.created_from_date = false"
                                            locale="ru"
                                            first-day-of-week="1"
                                            color="primary"
                                            max-width="200px"
                                        ></v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col md="6" class="ma-0 pa-0">
                                    <v-menu
                                        v-model="search.menu.created_till_date"
                                        ref="menuCreatedTillDate"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                        max-width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                @click:clear="search.filter.created_till_date = null"
                                                :value="createdTillDate"
                                                label="Дата добавления, до"
                                                prepend-icon="mdi-calendar"
                                                readonly
                                                clearable
                                                v-on="on"
                                                class="my-0 ml-3 pl-0 py-0"
                                                dense
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            v-model="search.filter.created_till_date"
                                            @change="search.menu.created_till_date = false"
                                            locale="ru"
                                            first-day-of-week="1"
                                            color="primary"
                                            max-width="200px"
                                        ></v-date-picker>
                                    </v-menu>
                                </v-col>
                            </v-row>
                            <v-row class="ma-0 pa-0">
                                <v-col md="6" class="ma-0 pa-0">
                                    <v-menu
                                        v-model="search.menu.updated_from_date"
                                        ref="menuUpdatedFromDate"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                        max-width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                @click:clear="search.filter.updated_from_date = null"
                                                :value="updatedFromDate"
                                                label="Дата контакта, от"
                                                prepend-icon="mdi-calendar"
                                                readonly
                                                clearable
                                                v-on="on"
                                                class="my-0 ml-0 pl-0 py-0"
                                                dense
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            v-model="search.filter.updated_from_date"
                                            @change="search.menu.updated_from_date = false"
                                            locale="ru"
                                            first-day-of-week="1"
                                            color="primary"
                                            max-width="200px"
                                        ></v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col md="6" class="ma-0 pa-0">
                                    <v-menu
                                        v-model="search.menu.updated_till_date"
                                        ref="menuUpdatedTillDate"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                        max-width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                @click:clear="search.filter.updated_from_date = null"
                                                :value="updatedTillDate"
                                                label="Дата контакта, до"
                                                prepend-icon="mdi-calendar"
                                                readonly
                                                clearable
                                                v-on="on"
                                                class="my-0 ml-3 pl-0 py-0"
                                                dense
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            v-model="search.filter.updated_till_date"
                                            @change="search.menu.updated_till_date = false"
                                            locale="ru"
                                            first-day-of-week="1"
                                            color="primary"
                                            max-width="200px"
                                        ></v-date-picker>
                                    </v-menu>
                                </v-col>
                            </v-row>
                            <v-checkbox
                                v-model="search.filter.is_recruitment"
                                :error-messages="search.errors.is_recruitment"
                                label="Подбор персонала"
                                class="ma-0 pa-0"
                            ></v-checkbox>
                            <v-checkbox
                                v-if="user.root"
                                v-model="search.filter.hidden"
                                label="Показать скрытые"
                                class="ma-0 pa-0"
                            ></v-checkbox>
                            <v-btn
                                :loading="search.loading"
                                type="submit"
                                color="primary"
                            >
                                Поиск
                            </v-btn>
                            <v-btn
                                @click="resetForm(); searchCompanies()"
                                :loading="search.loading"
                                color="default"
                                class="ml-5"
                            >
                                Очистить
                            </v-btn>
                            <div class="d-inline-block pl-10 mt-5">
                                Найдено компаний: {{ search.total }}
                            </div>
                        </v-form>
                        <br>
                        <v-col md="12">
                            <v-pagination
                                v-if="search.total > 100"
                                v-model="search.filter.page"
                                @input="searchCompanies"
                                :length="Math.ceil(search.total / 100)"
                                class="ma-0"
                            ></v-pagination>
                        </v-col>
                        <v-data-table
                            :headers="search.headers"
                            :items="search.data"
                            disable-sort
                            disable-pagination
                            hide-default-footer
                            :loading="search.loading"
                        >
                            <template v-slot:item="{ item }">
                                <tr>
                                    <td class="text-left">{{ item.id }}</td>
                                    <td class="text-left">{{ item.name }}</td>
                                    <td class="text-left">
                                        {{ item.status }}
                                        <v-chip v-if="item.is_recruitment" small color="primary" class="ma-1">Подбор</v-chip>
                                    </td>
                                    <td class="text-left">{{ item.manager }}</td>
                                    <td class="text-left">
                                        <div class="d-inline-flex align-center">
                                            <router-link
                                                :to="{name: 'MarketingCompanyView', params: {id: item.id}}"
                                                class="mr-2"
                                            >
                                                <v-icon
                                                    small
                                                >
                                                    mdi-eye
                                                </v-icon>
                                            </router-link>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                        <v-col md="12">
                            <v-pagination
                                v-if="search.total > 100"
                                v-model="search.filter.page"
                                @input="searchCompanies"
                                :length="Math.ceil(search.total / 100)"
                                class="ma-0"
                            ></v-pagination>
                        </v-col>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-dialog
            v-if="create.show"
            v-model="create.show"
            max-width="600"
        >
            <v-card>
                <v-card-title class="headline">Новая компания</v-card-title>
                <v-form
                    @submit.prevent="createCompany"
                    autocomplete="off"
                >
                    <v-card-text>
                        <v-text-field
                            v-model="create.data.name"
                            :error-messages="create.errors.name"
                            name="name"
                            label="Название"
                            type="text">
                        </v-text-field>
                        <v-select
                            v-model="create.data.source_id"
                            :error-messages="create.errors.source_id"
                            :items="source.search.data"
                            :cache-items="true"
                            item-text="name"
                            item-value="id"
                            label="Источник"
                        ></v-select>
                        <v-text-field
                            v-model="create.data.person"
                            :error-messages="create.errors.person"
                            name="person"
                            label="Ф.И.О."
                            type="text">
                        </v-text-field>
                        <v-text-field
                            v-model="create.data.email"
                            :error-messages="create.errors.email"
                            name="email"
                            label="Почта"
                            type="text">
                        </v-text-field>
                        <v-row>
                            <v-col md="8" class="py-0">
                                <v-text-field
                                    v-model="create.data.phone1"
                                    v-mask="'+7 (###) ###-##-##'"
                                    :error-messages="create.errors.phone1"
                                    name="phone1"
                                    label="Телефон"
                                    type="text"
                                ></v-text-field>
                            </v-col>
                            <v-col md="4" class="py-0">
                                <v-text-field
                                    v-model="create.data.phone_ext1"
                                    :error-messages="create.errors.phone_ext1"
                                    name="phone_ext1"
                                    label="Добавочный"
                                    type="text"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col md="8" class="py-0">
                                <v-text-field
                                    v-model="create.data.phone2"
                                    v-mask="'+7 (###) ###-##-##'"
                                    :error-messages="create.errors.phone2"
                                    name="phone2"
                                    label="Телефон"
                                    type="text"
                                ></v-text-field>
                            </v-col>
                            <v-col md="4" class="py-0">
                                <v-text-field
                                    v-model="create.data.phone_ext2"
                                    :error-messages="create.errors.phone_ext2"
                                    name="phone_ext2"
                                    label="Добавочный"
                                    type="text"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col md="8" class="py-0">
                                <v-text-field
                                    v-model="create.data.phone3"
                                    v-mask="'+7 (###) ###-##-##'"
                                    :error-messages="create.errors.phone3"
                                    name="phone3"
                                    label="Телефон"
                                    type="text"
                                ></v-text-field>
                            </v-col>
                            <v-col md="4" class="py-0">
                                <v-text-field
                                    v-model="create.data.phone_ext3"
                                    :error-messages="create.errors.phone_ext3"
                                    name="phone_ext3"
                                    label="Добавочный"
                                    type="text"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-select
                            v-if="user.root"
                            v-model="create.data.manager_id"
                            :error-messages="create.errors.manager_id"
                            :items="manager.search.data"
                            :cache-items="true"
                            item-text="name"
                            item-value="id"
                            label="Администратор"
                        ></v-select>
                        <v-checkbox
                            v-model="create.data.is_recruitment"
                            :error-messages="create.errors.is_recruitment"
                            label="Подбор персонала"
                            class="ma-0"
                        ></v-checkbox>
                        <v-checkbox
                            v-model="create.data.hidden"
                            label="Скрыть"
                            class="ma-0"
                        ></v-checkbox>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            @click="create.show = false"
                            :disabled="create.progress"
                            text
                            color="error"
                        >
                            Отменить
                        </v-btn>
                        <v-btn
                            :loading="create.progress"
                            type="submit"
                            color="primary"
                        >
                            Сохранить
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
export default {
    name: "MarketingCompanyController",
    data () {
        return {
            create: {
                data: {
                    email: '',
                    hidden: false,
                    is_recruitment: false,
                    manager_id: 0,
                    name: '',
                    person: '',
                    phone1: '',
                    phone2: '',
                    phone3: '',
                    phone_ext1: '',
                    phone_ext2: '',
                    phone_ext3: '',
                    source_id: 0,
                },
                errors: {
                    email: [],
                    is_recruitment: [],
                    manager_id: [],
                    name: [],
                    person: [],
                    phone1: [],
                    phone2: [],
                    phone3: [],
                    phone_ext1: [],
                    phone_ext2: [],
                    phone_ext3: [],
                    source_id: [],
                },
                progress: false,
                show: false,
            },
            manager: {
                search: {
                    data: [],
                    loading: true,
                },
            },
            search: {
                data: [],
                errors: {
                    is_recruitment: [],
                    manager_id: [],
                    source_id: [],
                    status_id: [],
                    term: [],
                    term_email: [],
                    term_id: [],
                    term_phone: [],
                },
                filter: {
                    created_from_date: null,
                    created_till_date: null,
                    hidden: false,
                    is_recruitment: false,
                    manager_id: '',
                    page: 1,
                    source_id: '',
                    status_id: '',
                    term: '',
                    term_email: '',
                    term_id: '',
                    term_phone: '',
                    updated_from_date: null,
                    updated_till_date: null,
                },
                headers: [
                    {
                        text: 'ID',
                        value: 'id',
                    },
                    {
                        text: 'Название',
                        value: 'name',
                    },
                    {
                        text: 'Статус',
                        value: 'email',
                    },
                    {
                        text: 'Администратор',
                        value: 'manager',
                    },
                    {
                        text: 'Действия',
                        value: 'id',
                    },
                ],
                loading: true,
                menu: {
                    created_from_date: false,
                    created_till_date: false,
                    updated_from_date: false,
                    updated_till_date: false,
                },
                total: 0,
            },
            source: {
                search: {
                    data: [],
                    loading: true,
                },
            },
            status: {
                search: {
                    data: [],
                    loading: true,
                },
            },
        }
    },
    computed: {
        createdFromDate () {
            return this.search.filter.created_from_date ? this.formatDate(this.search.filter.created_from_date) : ''
        },
        createdTillDate () {
            return this.search.filter.created_till_date ? this.formatDate(this.search.filter.created_till_date) : ''
        },
        updatedFromDate () {
            return this.search.filter.updated_from_date ? this.formatDate(this.search.filter.updated_from_date) : ''
        },
        updatedTillDate () {
            return this.search.filter.updated_till_date ? this.formatDate(this.search.filter.updated_till_date) : ''
        },
        user: function () {
            return this.$store.getters.user
        },
    },
    created () {
        this.searchCompanies()
        this.searchManagers()
        this.searchSources()
        this.searchStatuses()
    },
    methods: {
        createCompany: function () {
            this.create.progress = true

            this.$axios.post('/manager/marketing/company/create', this.create.data)
                .then((res) => {
                    if (res.data.success) {
                        this.create.show = false
                        this.create.data.email = ''
                        this.create.data.hidden = false
                        this.create.data.is_recruitment = false
                        this.create.data.manager_id = 0
                        this.create.data.name = ''
                        this.create.data.person = ''
                        this.create.data.phone1 = ''
                        this.create.data.phone2 = ''
                        this.create.data.phone3 = ''
                        this.create.data.phone_ext1 = ''
                        this.create.data.phone_ext2 = ''
                        this.create.data.phone_ext3 = ''
                        this.create.data.source_id = 0

                        this.searchCompanies()
                    } else {
                        this.create.errors.email = res.data.errors.email || []
                        this.create.errors.is_recruitment = res.data.errors.is_recruitment || []
                        this.create.errors.manager_id = res.data.errors.manager_id || []
                        this.create.errors.name = res.data.errors.name || []
                        this.create.errors.person = res.data.errors.person || []
                        this.create.errors.phone1 = res.data.errors.phone1 || []
                        this.create.errors.phone2 = res.data.errors.phone2 || []
                        this.create.errors.phone3 = res.data.errors.phone3 || []
                        this.create.errors.phone_ext1 = res.data.errors.phone_ext1 || []
                        this.create.errors.phone_ext2 = res.data.errors.phone_ext2 || []
                        this.create.errors.phone_ext3 = res.data.errors.phone_ext3 || []
                        this.create.errors.source_id = res.data.errors.source_id || []
                    }

                    this.create.progress = false
                })
                .catch(() => {
                    this.create.progress = false
                })
        },

        createCompanyPopup: function () {
            this.create.show = true
        },

        formatDate (date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}.${month}.${year}`
        },

        resetForm () {
            this.search.filter = {
                created_from_date: null,
                created_till_date: null,
                hidden: false,
                is_recruitment: false,
                manager_id: '',
                page: 1,
                source_id: '',
                status_id: '',
                term: '',
                term_email: '',
                term_id: '',
                term_phone: '',
                updated_from_date: null,
                updated_till_date: null,
            }
        },

        searchCompanies () {
            this.search.loading = true

            this.$axios.post('/manager/marketing/company/search', this.search.filter)
                .then(res => {
                    if (res.data.success) {
                        this.search.data = res.data.data.data
                        this.search.total = res.data.data.meta.total
                        this.search.errors.is_recruitment = []
                    } else {
                        this.search.errors.is_recruitment = res.data.errors.is_recruitment || []
                    }

                    this.search.loading = false
                })
                .catch(() => {
                    this.search.loading = false
                })
        },

        searchManagers () {
            this.manager.search.loading = true

            this.$axios.post('/manager/user/search')
                .then(res => {
                    if (res.data.success) {
                        this.manager.search.data = res.data.data.filter(m => {return m.manager})
                    }

                    this.manager.search.loading = false
                })
                .catch(() => {
                    this.manager.search.loading = false
                })
        },

        searchSources () {
            this.source.search.loading = true

            this.$axios.post('/manager/marketing/source/search')
                .then(res => {
                    if (res.data.success) {
                        this.source.search.data = res.data.data
                    }

                    this.source.search.loading = false
                })
                .catch(() => {
                    this.source.search.loading = false
                })
        },

        searchStatuses () {
            this.status.search.loading = true

            this.$axios.post('/manager/marketing/status/search')
                .then(res => {
                    if (res.data.success) {
                        this.status.search.data = res.data.data
                    }

                    this.status.search.loading = false
                })
                .catch(() => {
                    this.status.search.loading = false
                })
        },
    },
}
</script>

<style>
a {
    text-decoration: none;
}
</style>
